import { EntityPro2doc } from "../../entity/EntityPro2doc";

export class DtoPro2docsPostRes extends EntityPro2doc {}
